module.exports = __webpack_public_path__ + "static/img_4332-a9d15e535f01140daef5d2b93c2d5c02.webp";